import { useEffect, useState } from "react"

const useIsPhone = () => {
  const [isPhone, setIsPhone] = useState(false)

  useEffect(() => {
    const checkIfPhone = () => {
      const userAgent = navigator.userAgent
      const isMobileDevice =
        /Android|iPhone|iPod/i.test(userAgent) &&
        ("ontouchstart" in window || navigator.maxTouchPoints > 0)

      setIsPhone(isMobileDevice)
    }

    checkIfPhone()

    window.addEventListener("resize", checkIfPhone)

    return () => window.removeEventListener("resize", checkIfPhone)
  }, [])

  return isPhone
}

export default useIsPhone
